import { filesize } from "filesize";

export default function formatFileSize(size) {
  return filesize(size, { base: 2, standard: "jedec" });
}
